import {Typography, styled} from '@mui/material'
import DanceListItem from 'components/Display/DanceListItem/DanceListItem'
import {useI18n} from 'store/Store'

const DancesList = ({dances = [], handleRemoveDance, handleMoveDance}) => {
    const {i18n} = useI18n()

    if (!dances.length) {
        return (
            <EmptyState variant="body2" color="text.secondary">
                {i18n.t('danceCollections.listEmpty')}
            </EmptyState>
        )
    }

    return (
        <Container>
            {dances.map((dance, index) => (
                <DanceListItem
                    key={dance._id}
                    dance={dance}
                    index={index}
                    total={dances.length}
                    handleRemoveDance={handleRemoveDance}
                    handleMoveDance={handleMoveDance}
                />
            ))}
        </Container>
    )
}

export default DancesList

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
`

const EmptyState = styled(Typography)`
    padding: 40px 16px;
    text-align: center;
`
